import { createReducer, on } from '@ngrx/store';

import * as flightActions from '@flight-results/store/actions/flights-results.actions';
import * as packageActions from '@app/modules/packages/packages-result/store/actions/packages-result.actions';

import { AirFilterResponseVm } from '@shared/magic-filter-bar/entities/filter-types';
import { mappedAirFilterResponseVm } from '@app/mappers/global-filters/air-global-filters.mapper';

export const initialState: AirFilterResponseVm = {} as AirFilterResponseVm;

export const airFiltersReducer = createReducer(
  initialState,
  on(flightActions.fetchFiltersSuccessAction, (state, { filters }) => mappedAirFilterResponseVm(filters)),
  on(packageActions.fetchPackageAirFilterSuccessAction, (state, { response }) => mappedAirFilterResponseVm(response)),
  on(
    flightActions.clearFilterAction,
    flightActions.searchFlightsForDesktopErrorAction,
    packageActions.fetchPackageAirFilterAction,
    packageActions.searchPackageAction,
    () => initialState
  ),
);
